"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StampStatuses = void 0;
const StampStatuses = exports.StampStatuses = {
  AVAILABLE: "AVAILABLE",
  INVOICED: "INVOICED",
  DESTROYED: "DESTROYED"
};